import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DataProtectionSoftwareService from "src/modules/data-protection/apis/DataProtectionSoftwareService";

/**
 * Status, completion and visibility of every assessment card in one request,
 * so the navigation cards do not depend on the questionnaires being mounted.
 */
const useAssessmentCards = (softwareId, { enabled = true, t } = {}) => {
    return useQuery({
        queryKey: ["gdpr-software-assessment-cards", softwareId],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();

            return await service.assessmentCards(softwareId);
        },
        enabled: Boolean(softwareId && enabled),
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(
                t
                    ? t("An error occurred while fetching assessments.")
                    : "An error occurred while fetching assessments.",
                {
                    type: "error"
                }
            );
        }
    });
};

export default useAssessmentCards;
